import { Record } from 'immutable';

export interface TimezoneFields {
  id: string;
  name: string;
  offset: number;
  olson_id: string;
}

export default class Timezone extends Record<TimezoneFields>({
  id: '',
  name: '',
  offset: 0,
  olson_id: '',
}) {
  humanOffset() {
    return `GMT${this.offset >= 0 ? `+${this.offset}` : this.offset}`;
  }

  humanFullTimezone() {
    return `(${this.humanOffset()}) ${this.name}`;
  }
}
